import { Snackbar } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'shared/hooks';
import { selectAlert } from 'shared/selectors/admin/alert';
import { hideAlert } from 'shared/slices/admin/alert';

export const AlertContainer: React.FC = React.memo(() => {
  const dispatch = useAppDispatch();

  const { isVisible, type, message } = useSelector(selectAlert);

  const onCloseHandler = React.useCallback(() => dispatch(hideAlert()), [dispatch]);

  return <Snackbar status={type} message={message} open={isVisible} onClose={onCloseHandler} autoHideDuration={3000} />;
});

AlertContainer.displayName = 'AlertContainer';
